<template>
  <files-upload ref="uploadFiles" :overlay="false" :clickable="false" :project-id="project.id"
                @hide="showUpload = false" :show="true">
    <template slot="content">
      <div class="project-item" :id="'project-item-' + project.id">
        <div class="project-item__folder top-bar" :class="{'expanded': showFiles}" @click="handleToggleProjectFiles">
          <div class="top-bar--left">
            <i class="icon icon--file icon--file--big-number">
              <span>{{project.fcount}}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill-rule="evenodd"
                   clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
                <g>
                  <path class="file-body"
                        d="M14 1.635C14 .733 13.267 0 12.365 0H4.913L0 4.684v9.681C0 15.267.733 16 1.635 16h10.73c.902 0 1.635-.733 1.635-1.635V1.635z"
                        :fill="project.color"/>
                  <path d="M4.913 0v3.069c-.043.899-.711 1.569-1.631 1.615H0L4.848.063 4.913 0z"
                        fill-opacity=".2"/>
                </g>
              </svg>
            </i>
            <div class="project-item__folder__title">
              <h3>{{project.name}}</h3>
            </div>
            <i class="icon icon--play" :class="{'icon--play--rotate': showFiles}"></i></div>
          <div class="top-bar--right" @click.stop>
            <b-button v-if="project.owner !== 'f'" size="-small" variant="-ternary btn--outline" @click="edit">{{$t('buttons.edit')}}
            </b-button>
            <!--<b-button size="-txt" variant="-txt--white" v-if="isUserInOrganisation">Status</b-button>-->
            <b-button v-if="project.owner !== 'f'" size="-small" variant="-ternary btn--outline"
                      @click="sharingShow = true">{{$t('buttons.share')}}
            </b-button>
            <b-button variant="-ternary btn--outline btn--trash" size="-small" @click="setDeleteProject">
              <svg class="icon icon--trash">
                <use xlink:href="#trash"></use>
              </svg>
            </b-button>
          </div>
        </div>
        <b-collapse v-model="showFiles" class="table table--projects">
          <container-loader class="p-2" v-if="!filesLoaded"></container-loader>
          <files-table v-else :items="files" @forceUpdateFiles="loadProjectFiles"></files-table>
        </b-collapse>

        <edit-project :show="editShow" @hide="editShow = false" :project="project"></edit-project>

        <b-modal v-model="sharingShow" size="lg" hide-footer>
          <share-project :project-id="project.id"></share-project>
        </b-modal>

      </div>
    </template>
  </files-upload>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import FilesTable from '../files/FilesTable';
  import EditProject from '@/components/projects/modal/EditProject';
  import EventBus from "../../event/event-bus";
  import ShareProject from "../files/modal/ShareProject";

  import FilesUpload from "@/components/apps/upload/FilesUpload";

  export default {
    name: 'project-item',
    components: {ShareProject, FilesTable, EditProject, FilesUpload},
    props: {
      project: {
        type: Object,
        required: true
      },
      forceShowFiles: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        editShow: false,
        showFiles: false,
        filesLoaded: false,
        sharingShow: false,
        showFilesListener: null
      }
    },
    created() {
      this.filesLoaded = this.files.length > 0;
      this.showFiles = this.forceShowFiles;
      if (this.showFiles && !this.filesLoaded) {
        this.loadProjectFiles();
      }
      this.showFilesListener = EventBus.$on('project:show', projectId => {
        if (projectId == this.project.id && !this.showFiles) {
          this.handleToggleProjectFiles();
        }
      })
    },
    beforeDestroy() {
      EventBus.$off('project:show', this.showFilesListener);
    },
    computed: {
      ...mapGetters(['getFilesByProjectId', 'isUserInOrganisation']),

      files() {
        return this.getFilesByProjectId(this.project.id);
      }
    },
    methods: {
      ...mapActions(['fetchFilesByParams', 'deleteProject']),

      edit(){
        this.editShow = true
      },
      handleToggleProjectFiles() {
        this.showFiles = !this.showFiles;
        if (this.showFiles && !this.filesLoaded) {
          this.loadProjectFiles();
        }
      },

      loadProjectFiles() {
        this.fetchFilesByParams({'project_id': this.project.id}).then(() => {
          this.filesLoaded = true;
        });
      },
      setDeleteProject(){

        const action = this.project.owner === true || this.project.owner === 't' ? 'delete' : 'unshare';

        //this.msgBoxConfirm('You are going to ' + action + ' the ' +  this.project.name + ' project, please confirm your action.')
        this.msgBoxConfirm(this.$t('projects.delete', {action: this.$t('buttons.' + action).toLocaleLowerCase(), projectName: this.project.name }),{
          okTitle: this.$t('buttons.ok'),
          cancelTitle: this.$t('buttons.cancel'),
        })
                .then(value => {
                  if(value){
                    this.deleteProject(this.project.id)
                  }
                })
      }
    },
    watch: {
      forceShowFiles: function(val) {
        if (val && !this.filesLoaded) {
          this.loadProjectFiles();
        }
        this.showFiles = val;
      }
    }
  }
</script>

<style lang="scss">
  @import "../../scss/theme";
  .project-item {
    left: 41px;
    position: relative;
    margin-bottom: 20px;
    width: calc(100% - 41px);
    &__folder {
      cursor: pointer;
      padding: 8px 8px 8px 20px;
      background: white;
      border-radius: $s-border-radius;
      position: relative;
      transition: all .1s;
      box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.05);
      font-weight: 700;

      &.expanded {
        border-radius: $s-border-radius $s-border-radius 0 0;
      }

      &.top-bar {
        margin-bottom: 0;

        &--left {
          min-width: 50%;
        }
        .icon--trash {
          height: 20px;
          width: 20px;
          left: -1px;
          top: -2px;
        }
      }

      &__title {
        h3 {
          font-size: 14px;
          font-weight: 700;
          margin: 0;
        }

      }

      .icon--file {
        position: absolute;
        left: -30px;
        top: 12.5px;
        span {
          font-size: 16px;
          left: 1px;
          text-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        }
        svg {
          z-index: 1;
          left: 3px;
          position: absolute;
          transform: scale(1.95);
        }
      }
    }
    div.table {
      table.table {
        border-radius: 0 0 $s-border-radius $s-border-radius;
        border: 0;
        tr:first-child {
          border: 0;
        }
      }
    }
  }
</style>
